import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
//
import { dispatch } from "../store";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  limit_boules_user: {
    count: 0,
    data: [],
    num_pages: 1,
    page: 1,
    page_size: "5",
  },
};

const slice = createSlice({
  name: "limitbouleagent",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET LIMIT BOULE USER
    getLimitBouleUserSuccess(state, action) {
      state.isLoading = false;
      state.limit_boules_user = action.payload;
    },

    // ADD LIMIT BOULE USER
    addLimitBouleUserSuccess(state, action) {
      const limitboule = action.payload;
      state.limit_boules_user.data.push(limitboule);
      state.limit_boules_user.count += 1;
    },

    // UPDATE LIMIT BOULE USER
    updateLimitBouleUserSuccess(state, action) {
      const limitboule = action.payload;
      if (state.limit_boules_user && state.limit_boules_user.data) {
        const limitbouleIndex = state.limit_boules_user?.data?.findIndex(
          (obj) => obj.id === limitboule.id
        );
        if (limitbouleIndex !== -1) {
          state.isLoading = false;
          state.limit_boules_user.data[limitbouleIndex] = limitboule;
        }
      } else {
        state.limit_boules_user = { data: [] };
        state.limit_boules_user.data.push(limitboule);
      }
    },

    // DELETE LIMIT BOULE USER
    deleteLimitBouleUserSuccess(state, action) {
      const deletedLimitBouleId = action.payload;
      state.limit_boules_user.data = state.limit_boules_user.data.filter(
        (limitboule) => limitboule.id !== deletedLimitBouleId
      );
      state.isLoading = false;
    },

    // DELETE LIMIT BOULES USER
    deleteLimitBoulesUserSuccess(state, action) {
      const deletedLimitBouleIds = action.payload;
      state.limit_boules_user.data = state.limit_boules_user.data.filter(
        (limitboule) => !deletedLimitBouleIds.includes(limitboule.id)
      );
      state.isLoading = false;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  addLimitBouleUserSuccess,
  updateLimitBouleUserSuccess,
  deleteLimitBouleUserSuccess,
  deleteLimitBoulesUserSuccess,
} = slice.actions;

// ----------------------------------------------------------------------

export function getLimitBoulesUser(page = 1, rowsPerPage = 5) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/dashboard/limit-boule-user?page=${page}&page_size=${rowsPerPage}`
      );
      dispatch(slice.actions.getLimitBouleUserSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export async function getLimitBouleUser(keyId) {
  const response = await axios.get(
    `/api/dashboard/limit-boule-user-id?keyId=${keyId}`
  );
  return response.data;
}

export async function addLimitBouleUser(data) {
  const response = await axios.post(`/api/dashboard/limit-boule-user`, data);
  return response.data;
}

export async function updateLimitBouleUser(data) {
  const response = await axios.put(`/api/dashboard/limit-boule-user`, data);
  return response.data;
}

export async function deleteLimitBouleUser(keyId) {
  const response = await axios.delete(`/api/dashboard/limit-boule-user/${keyId}/`);
  return response.data;
}

export async function deleteLimitBoulesUser(keyIds) {
  const response = await axios.delete(`/api/dashboard/limit-boule-user-id`, {
    data: { keyIds },
  });
  return response.data;
}